import { useState, useEffect } from "react";
import { t, Trans } from "@lingui/macro";
import Link from "next/link";
import { Locale } from "src/lib/Intl";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { formatName } from "src/utils/formatName";
import { allBrandsSorted } from "src/organisms/AllBrandsSearch/sortBrands";
import { ToggleWishListBrandButton } from "./ToggleWishListBrandButton";
import {
  Wrapper,
  InputWrapper,
  Input,
  StyledSearchIcon,
  Content,
  ContentItem,
  Item,
  NoResults,
} from "./SearchMobileView.styled";
import { useLingui } from "@lingui/react";
import type { AllBrandData } from "src/types/adapters/browse.type";

type SearchMobileViewProps = {
  brands: AllBrandData[];
  genderId?: string;
  locale: Locale;
};

function SearchMobileView({ brands, genderId, locale }: SearchMobileViewProps) {
  const { i18n } = useLingui();
  const sortedBrands = allBrandsSorted(brands);
  const [searchVal, setSearchVal] = useState("");
  const [brandsSortedMobile, setBrandsSortedMobile] = useState(sortedBrands);

  useEffect(() => {
    if (searchVal) {
      const formattedSearchVal = searchVal.toLowerCase().replace(/ /g, "");
      const searchResultsMobile = sortedBrands.filter((el) =>
        formatName(el.name)
          .toLowerCase()
          .replace(/ /g, "")
          .includes(formattedSearchVal)
      );
      return setBrandsSortedMobile(searchResultsMobile);
    } else if (sortedBrands) {
      return setBrandsSortedMobile(sortedBrands);
    }
  }, [searchVal, sortedBrands]);

  return (
    <Wrapper>
      <InputWrapper>
        <Input
          type="text"
          placeholder={t(i18n)`Search A-Z brands`}
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
        />
        {!searchVal && <StyledSearchIcon />}
      </InputWrapper>
      <Content>
        {brandsSortedMobile?.map((brand) => (
          <Link
            key={brand.id}
            href={
              genderId
                ? "/[slug]/[brandSlug]/[genderId]"
                : "/[slug]/[brandSlug]"
            }
            as={
              genderId
                ? `${getI18nRoute({
                    route: `/brands`,
                    locale,
                  })}/${brand.slug || brand.value}${getI18nRoute({
                    route: `/${genderId}`,
                    locale,
                  })}`
                : `${getI18nRoute({
                    route: `/brands`,
                    locale,
                  })}/${brand.slug || brand.value}`
            }
            passHref
            legacyBehavior
          >
            <ContentItem key={brand.id}>
              <Item>
                {formatName(brand.name)}
                <ToggleWishListBrandButton
                  brandId={brand.id}
                  brandName={brand.name}
                />
              </Item>
            </ContentItem>
          </Link>
        ))}

        {brandsSortedMobile?.length === 0 && (
          <NoResults>
            <Trans>No brands found</Trans>
          </NoResults>
        )}
      </Content>
    </Wrapper>
  );
}

export default SearchMobileView;
